// 보험사/공제사 전산 링크 모음 (UI 렌더링용 데이터)
// - 외부 링크는 target=_blank 로 열리므로, 보안상 rel="noreferrer noopener"를 항상 사용한다.

const ext = (href) => ({ text: '열기', href })
const tel = (display) => {
  const digits = String(display || '').replace(/[^0-9]/g, '')
  if (!digits) return { text: String(display || '-') }
  return { text: String(display), href: `tel:${digits}` }
}

// 여러 번호/설명 섞인 경우 자동 링크를 만들지 않고 그대로 표시
const txt = (text) => ({ text: String(text || '-') })

export const INSURER_SYSTEMS_SECTIONS = [
  {
    id: 'fire',
    title: '손해보험사',
    firstColLabel: '보험회사 전산',
    items: [
      {
        name: '삼성화재',
        logoUrl: 'https://fctalk.co.kr/img/damoa/samsungfire.jpg',
        systemUrl: 'https://erp.samsungfire.com/irj/servlet/prt/portal/prtroot/logon.LogonPage',
        customerCenter: [tel('1588-5114')],
        inCall: [tel('1566-0553')],
        helpDesk: [tel('1899-5005')],
        claimFax: [txt('0505-162-0872')],
        termsUrl: 'https://www.samsungfire.com/page/VH.REIF0011.do',
        formUrl: 'https://drive.google.com/file/d/1QgctKnCo3dSUV71owUW0VQTmf_ovsKTC/view?usp=sharing',
      },
      {
        name: '메리츠화재',
        logoUrl: 'https://fctalk.co.kr/img/damoa/meritz.png',
        systemUrl: 'http://sales.meritzfire.com/',
        customerCenter: [tel('1566-7711')],
        inCall: [tel('1577-7711')],
        helpDesk: [tel('02-3786-2777')],
        claimFax: [txt('0505-021-3400(3500)')],
        termsUrl: 'https://www.meritzfire.com/disclosure/product-announcement/product-list.do#!/',
        formUrl: 'https://drive.google.com/file/d/1trOljP9JQD4IfDO0CK5VCYVKVrMFQ8gg/view?usp=sharing',
      },
      {
        name: 'DB손해보험',
        logoUrl: 'https://fctalk.co.kr/img/damoa/db.jpg',
        systemUrl: 'https://www.mdbins.com/chrome.html?ver=20241009',
        customerCenter: [tel('1588-0100')],
        inCall: [tel('1566-0757')],
        helpDesk: [tel('02-2262-1241')],
        claimFax: [txt('0505-181-4862')],
        termsUrl: 'https://www.idbins.com/FWMAIV1534.do',
        formUrl: 'https://drive.google.com/file/d/13yPdTcAOhFaHU3LdDHDOyp1EEIHzhTE9/view?usp=sharing',
      },
      {
        name: 'KB손해보험',
        logoUrl: 'https://fctalk.co.kr/img/damoa/kb.png',
        systemUrl: 'http://sales.kbinsure.co.kr/',
        customerCenter: [tel('1544-0114')],
        inCall: [tel('1544-0019')],
        helpDesk: [tel('1544-8119')],
        claimFax: [txt('0505-136-6500')],
        termsUrl: 'https://www.kbinsure.co.kr/CG802030001.ec',
        formUrl: 'https://drive.google.com/file/d/12q2cUkI5YsRuA3ljBpL2bu7lUgxlF5MH/view?usp=sharing',
      },
      {
        name: '현대해상',
        logoUrl: 'https://fctalk.co.kr/img/damoa/hyundai.jpg',
        systemUrl: 'https://sp.hi.co.kr/',
        customerCenter: [tel('1588-5656')],
        inCall: [tel('1577-3223')],
        helpDesk: [tel('02-2628-4567')],
        claimFax: [txt('0507-774-6060')],
        termsUrl: 'https://www.hi.co.kr/serviceAction.do?view=bin/PA/03/HHPA03010M#none',
        formUrl: 'https://drive.google.com/file/d/1x12XzHK7VIB9sJd-y8Ue3fQzxhn_updg/view?usp=sharing',
      },
      {
        name: '한화손해보험',
        logoUrl: 'https://fctalk.co.kr/img/damoa/hanhwa.png',
        systemUrl: 'http://portal.hwgeneralins.com/',
        customerCenter: [tel('1566-8000')],
        inCall: [tel('1670-1882')],
        helpDesk: [tel('02-316-0111')],
        claimFax: [txt('02-779-1004')],
        termsUrl: 'https://www.hwgeneralins.com/notice/ir/product-ing01.do',
        formUrl: 'https://drive.google.com/file/d/16HFvOB8k0nps2EyZ3HBlF0sXUKGQmUSa/view?usp=sharing',
      },
      {
        name: '롯데손해보험',
        logoUrl: 'https://fctalk.co.kr/img/damoa/lotte.jpg',
        systemUrl: 'http://lottero.lotteins.co.kr/',
        customerCenter: [tel('1588-3344')],
        inCall: [tel('1600-5182')],
        helpDesk: [tel('02-3455-3984')],
        claimFax: [txt('0507-333-9999')],
        termsUrl: 'https://www.lotteins.co.kr/web/C/D/H/cdh190.jsp',
        formUrl: 'https://drive.google.com/file/d/1OIXPlQPInxiI0kL0kl2nuMLXN9iRk_hv/view?usp=sharing',
      },
      {
        name: '흥국화재',
        logoUrl: 'https://fctalk.co.kr/img/damoa/heungkuk.png',
        systemUrl: 'https://sales.heungkukfire.co.kr/',
        customerCenter: [tel('1688-1688')],
        inCall: [tel('1688-6997')],
        helpDesk: [tel('031-786-8088')],
        claimFax: [txt('0504-800-0700')],
        termsUrl: 'https://www.heungkukfire.co.kr/FRW/announce/insGoodsGongsiSale.do',
        formUrl: 'https://drive.google.com/file/d/12PSz_JtZwJCm3MJIK_M-MSeDnGceKCFT/view?usp=sharing',
      },
      {
        name: '하나손해보험',
        logoUrl: 'https://fctalk.co.kr/img/damoa/hana.jpg',
        systemUrl: 'https://sfa.saleshana.com/index.html',
        customerCenter: [tel('1566-3000')],
        inCall: [tel('02-6299-6821')],
        helpDesk: [tel('02-6670-8110')],
        claimFax: [tel('0505-170-0765')],
        termsUrl: 'https://www.hanainsure.co.kr/w/disclosure/product/saleProduct',
        formUrl: 'https://drive.google.com/file/d/1DucoC3d5NmqfGFUTyciQfvVJE2td5CET/view?usp=sharing',
      },
      {
        name: '농협손해보험',
        logoUrl: 'https://fctalk.co.kr/img/damoa/nh.png',
        systemUrl: 'https://ss.nhfire.co.kr/',
        customerCenter: [tel('1644-9000')],
        inCall: [tel('1644-9600')],
        helpDesk: [tel('1644-0090')],
        claimFax: [txt('0505-060-7000')],
        termsUrl: 'https://www.nhfire.co.kr/announce/productAnnounce/retrieveInsuranceProductsAnnounce.nhfire',
        formUrl: 'https://drive.google.com/file/d/1C_U2HoRaxTpQkRu0hRLVnkg9PIgL65_t/view?usp=sharing',
      },
      {
        name: '라이나손해보험',
        logoUrl: 'https://fctalk.co.kr/img/damoa/lina.png',
        systemUrl: 'https://ga.linagi.com/',
        customerCenter: [tel('1566-5800')],
        inCall: [tel('1833-9513')],
        helpDesk: [txt('02-2127-2308 (치아 02-6913-8482)')],
        claimFax: [txt('-')],
        termsUrl: 'https://www.chubb.com/kr-kr/disclosure/product.html',
        formUrl: 'https://www.chubb.com/kr-kr/claims/report-a-claim.html',
      },
      {
        name: 'AIG',
        logoUrl: 'https://fctalk.co.kr/img/damoa/aig.jpg',
        systemUrl: 'https://sso.aig.co.kr/gaLogin/gaLogin.jsp',
        customerCenter: [tel('1544-2792')],
        inCall: [tel('1544-2792')],
        helpDesk: [tel('02-2260-6855')],
        claimFax: [tel('02-2011-4607')],
        termsUrl: 'https://www.aig.co.kr/wo/dpwot001.html?menuId=MS702',
        formUrl: 'https://drive.google.com/file/d/1rzYhHxpzcVjwIJg5qGpmZygzl2R7Db9u/view?usp=sharing',
      },
      {
        name: 'MG손해보험',
        logoUrl: 'https://fctalk.co.kr/img/damoa/mg.jpg',
        systemUrl: 'https://mganet.mggeneralins.com/',
        customerCenter: [tel('1588-5959')],
        inCall: [tel('1577-3777')],
        helpDesk: [tel('02-3788-2261')],
        claimFax: [txt('0505-088-1646')],
        termsUrl: 'https://www.mggeneralins.com/PB031210DM.scp?menuId=MN0803006',
        formUrl: 'https://drive.google.com/file/d/1sxkvtD3kOVBpN55XDoTuevKFpN7l6Yyi/view?usp=sharing',
      },
    ],
  },
  {
    id: 'life',
    title: '생명보험사',
    firstColLabel: '보험회사 전산',
    items: [
      {
        name: '한화생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/hanhwa_life.jpg',
        systemUrl: 'https://hmp.hanwhalife.com/online/ga',
        customerCenter: [tel('1588-6363')],
        inCall: [tel('1800-6633')],
        helpDesk: [txt('02-1522-6379')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://www.hanwhalife.com/main/disclosure/goods/disclosurenotice/DF_GDDN000_P10000.do?MENU_ID1=DF_GDGL000',
        formUrl: 'https://drive.google.com/file/d/1fZZpLHqzDV2SyYgzn8IH5SmfvDHids6Z/view?usp=drive_link',
      },
      {
        name: '동양생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/dy_life.jpg',
        systemUrl: 'http://1004.myangel.co.kr/',
        customerCenter: [tel('1577-1004')],
        inCall: [tel('080-899-1004')],
        helpDesk: [tel('02-728-9900')],
        claimFax: [tel('02-3289-4517')],
        termsUrl: 'https://www.myangel.co.kr/paging/WE_AC_WEPAAP020100L',
        formUrl: 'https://drive.google.com/file/d/11K6eNf-c7fsojr4CvRkNVQkVPes8OiPv/view?usp=drive_link',
      },
      {
        name: '교보생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/kyobo_life.png',
        systemUrl: 'https://ga.kyobo.com/',
        customerCenter: [tel('1588-1001')],
        inCall: [tel('1588-1636')],
        helpDesk: [tel('02-721-3130')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://www.kyobo.com/dgt/web/product-official/all-product/search',
        formUrl: 'https://drive.google.com/file/d/1CajZ-tRE-SKemelGx9DtBKxm2_kXhuRT/view?usp=drive_link',
      },
      {
        name: '삼성생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/samsung_life.jpg',
        systemUrl: 'https://connectplus.samsunglife.com:10443/gasso/login',
        customerCenter: [tel('1588-3114')],
        inCall: [tel('1588-3115')],
        helpDesk: [tel('02-311-4500')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://www.samsunglife.com/individual/products/disclosure/sales/PDO-PRPRI010110M',
        formUrl: 'https://drive.google.com/file/d/1ei1KXYlv5YaJz_-OvPYAOH1BzfgyWtqd/view?usp=drive_link',
      },
      {
        name: '라이나생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/lina_life.png',
        systemUrl: 'https://ga.lina.co.kr/',
        customerCenter: [tel('1588-0058')],
        inCall: [tel('1588-2442')],
        helpDesk: [tel('02-3781-2006')],
        claimFax: [tel('02-6944-1200')],
        termsUrl: 'https://www.lina.co.kr/disclosure/product_list.htm?productState=01&productKind=01',
        formUrl: 'https://drive.google.com/file/d/1DSIFv9NmmQjKAmjVddKzG5UENSfftUq8/view?usp=drive_link',
      },
      {
        name: 'KDB생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/kdb_life.png',
        systemUrl: 'http://kss.kdblife.co.kr/',
        customerCenter: [tel('1588-4040')],
        inCall: [tel('1588-4040')],
        helpDesk: [tel('02-6303-2771')],
        claimFax: [txt('접수 후 02-2669-7930')],
        termsUrl: 'https://www.kdblife.co.kr/ajax.do?scrId=HDLMA002M02P',
        formUrl: 'https://drive.google.com/file/d/1VvIMb4Y0MHsyLnrpfzJXfZw01WPBPBhf/view?usp=drive_link',
      },
      {
        name: 'IM 라이프',
        logoUrl: 'https://fctalk.co.kr/img/damoa/im_life.png',
        systemUrl: 'https://fgs.dgbfnlife.com:8443/',
        customerCenter: [tel('1588-4770')],
        inCall: [tel('1588-4770')],
        helpDesk: [tel('02-2087-9594')],
        claimFax: [txt('0505-083-5420')],
        termsUrl: 'https://www.dgbfnlife.com/BA/BA_A020.do',
        formUrl: 'https://drive.google.com/file/d/1750HUcw9GDwo9EtFO-pf-FqowxC7Eb24/view?usp=drive_link',
      },
      {
        name: '미래에셋생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/mirae_life.png',
        systemUrl: 'http://www.loveageplan.com/',
        customerCenter: [tel('1588-0220')],
        inCall: [tel('1588-0220')],
        helpDesk: [tel('02-3271-5108')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://life.miraeasset.com/micro/disclosure/product/PC-HO-080301-000000.do',
        formUrl: 'https://drive.google.com/file/d/1uXnAwFSCNLtLcSrYUILeIa5o3vWBQ3Ce/view?usp=drive_link',
      },
      {
        name: '신한라이프',
        logoUrl: 'https://fctalk.co.kr/img/damoa/shinhan_life.jpg',
        systemUrl: 'https://ga.shinhanlife.co.kr/',
        customerCenter: [tel('1588-5580')],
        inCall: [tel('1522-2285')],
        helpDesk: [tel('02-3455-4119')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://www.shinhanlife.co.kr/hp/cdhi0010.do',
        formUrl: 'https://drive.google.com/file/d/180JkTJ-aiwuyVajOEbvd-g5LWPazM4eD/view?usp=drive_link',
      },
      {
        name: 'KB 라이프',
        logoUrl: 'https://fctalk.co.kr/img/damoa/kb_life.jpg',
        systemUrl: 'http://sfa.kblife.co.kr/',
        customerCenter: [tel('1588-3374')],
        inCall: [tel('1566-2730')],
        helpDesk: [tel('1899-3899')],
        claimFax: [tel('02-6220-9912')],
        termsUrl: 'https://www.kblife.co.kr/?/=true&tab=currently-selling',
        formUrl: 'https://drive.google.com/file/d/1LUHfTwOOHq-VV8QqAKoMGBQH3P220vU2/view?usp=drive_link',
      },
      {
        name: 'DB생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/db_life.jpg',
        systemUrl: 'http://etopia.dongbulife.com/',
        customerCenter: [tel('1588-3131')],
        inCall: [tel('02-6470-7663')],
        helpDesk: [tel('02-2119-5151')],
        claimFax: [txt('0505-129-3134')],
        termsUrl: 'https://www.idblife.com/notice/product/sale',
        formUrl: 'https://drive.google.com/file/d/1U6DWtGKmqZiUug3Ns3Ap-CUXLSrVBsVL/view?usp=drive_link',
      },
      {
        name: '하나생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/hana_life.gif',
        systemUrl: 'https://ga.hanalife.co.kr/',
        customerCenter: [tel('1577-1112')],
        inCall: [tel('1577-1112')],
        helpDesk: [txt('02-3709-8602~3')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://hanalife.co.kr/anm/product/allProduct.do?status=on',
        formUrl: 'https://drive.google.com/file/d/1VcePJKgwgHttWTDgAmRhM-wGrqIsnAoo/view?usp=drive_link',
      },
      {
        name: '흥국생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/heungkuk_life.jpg',
        systemUrl: 'https://sales.heungkuklife.co.kr/',
        customerCenter: [tel('1588-2288')],
        inCall: [tel('1877-7006')],
        helpDesk: [tel('031-786-8088')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://www.heungkuklife.co.kr/front/public/saleProduct.do?searchFlgSale=Y',
        formUrl: 'https://drive.google.com/file/d/1-uzttgDn0z6V5mpK9t0Vhu-ZAnXbyLTb/view?usp=drive_link',
      },
      {
        name: 'ABL 생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/abl_life.jpg',
        systemUrl: 'http://ga.abllife.co.kr/',
        customerCenter: [tel('1588-6500')],
        inCall: [tel('1566-1002')],
        helpDesk: [tel('02-3787-8583')],
        claimFax: [tel('02-3299-5544')],
        termsUrl: 'https://www.abllife.co.kr/st/pban/prdtPban/whlPrdt/whlPrdt1/whlPrdt11?page=index',
        formUrl: 'https://drive.google.com/file/d/1vixPje9GgiaJFJ026dQ3Xv_lsdmt-UzX/view?usp=drive_link',
      },
      {
        name: 'IBK 연금보험',
        logoUrl: 'https://fctalk.co.kr/img/damoa/ibk_life.jpg',
        systemUrl: 'https://sf.ibki.co.kr/',
        customerCenter: [tel('1577-4117')],
        inCall: [tel('02-2270-1661')],
        helpDesk: [tel('02-2270-1692')],
        claimFax: [tel('02-2270-1577')],
        termsUrl: 'https://www.ibki.co.kr/process/HP_PBANO_PDT_SP_INDV',
        formUrl: 'https://www.ibki.co.kr/process/HP_CSCETR_POSN_DOC_INS_LIST?bltb_cod=SC000014&sctn=in&TAB=in',
      },
      {
        name: 'NH농협생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/nh_life.jpg',
        systemUrl: 'http://www.nhlife.co.kr/nhsmart.nhl',
        customerCenter: [tel('1544-4000')],
        inCall: [tel('1544-4422')],
        helpDesk: [tel('02-3786-8800')],
        claimFax: [tel('02-6971-6040')],
        termsUrl: 'https://www.nhlife.co.kr/ho/on/HOON0004M00.nhl',
        formUrl: 'https://drive.google.com/file/d/1wvcKozPHqeMiiG6I2qAfrSadHLOh9zGv/view?usp=drive_link',
      },
      {
        name: 'MetLife',
        logoUrl: 'https://fctalk.co.kr/img/damoa/met_life.jpg',
        systemUrl: 'https://metplus.metlife.co.kr/WebCudeSetup.jsp',
        customerCenter: [tel('1588-9600')],
        inCall: [tel('1588-9600')],
        helpDesk: [tel('1899-0751')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://brand.metlife.co.kr/pn/paReal/insuProductDisclMain.do',
        formUrl: 'https://drive.google.com/file/d/1gQfLJW1RPFmT-8Ts8FxbYKkXlLswa5kV/view?usp=drive_link',
      },
      {
        name: 'Chubb Life',
        logoUrl: 'https://fctalk.co.kr/img/damoa/chuub_life.jpg',
        systemUrl: 'http://esmart.chubblife.co.kr/',
        customerCenter: [tel('1599-4600')],
        inCall: [tel('1599-4600')],
        helpDesk: [tel('1599-4646')],
        claimFax: [tel('02-3480-7801')],
        termsUrl: 'https://www.chubblife.co.kr/front/official/sale/list.do',
        formUrl: 'https://drive.google.com/file/d/1SIVz6aFl2bZz9b-gyAq6yc8VEhPVhJJH/view?usp=sharing',
      },
      {
        name: '푸본현대생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/pb_life.jpg',
        systemUrl: 'https://ez.fubonhyundai.com/',
        customerCenter: [tel('1577-3311')],
        inCall: [txt('-')],
        helpDesk: [tel('080-860-1212')],
        claimFax: [txt('0505-106-0311')],
        termsUrl: 'https://www.fubonhyundai.com/#CUSI150102010101',
        formUrl: 'https://drive.google.com/file/d/15uo9i1JZziRWjJz4rk_VTDZ31KVRLFlx/view?usp=drive_link',
      },
      {
        name: 'BNP 파리바 카디프생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/bnp_life.jpg',
        systemUrl: 'http://ga.cardif.co.kr/',
        customerCenter: [tel('1688-1118')],
        inCall: [tel('1688-1118')],
        helpDesk: [tel('1577-3435')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://www.cardif.co.kr/disclosure/papag101.do',
        formUrl: 'https://drive.google.com/file/d/1iJa5jHDg6Yuh4XvuGiv0PwtSZqHYmE3u/view?usp=drive_link',
      },
      {
        name: 'AIA 생명',
        logoUrl: 'https://fctalk.co.kr/img/damoa/aia_life.jpg',
        systemUrl: 'https://imap.aia.co.kr/',
        customerCenter: [tel('1588-9898')],
        inCall: [tel('1588-2513')],
        helpDesk: [tel('1588-2937')],
        claimFax: [tel('02-2021-4540')],
        termsUrl: 'https://www.aia.co.kr/ko/our-products.html',
        formUrl: 'https://drive.google.com/file/d/1-QM4hkOVBRcCx438USwk-d3ddvqW9DeO/view?usp=drive_link',
      },
    ],
  },
  {
    id: 'mutual',
    title: '공제회사',
    firstColLabel: '공제회사 홈페이지',
    items: [
      {
        name: 'MG 새마을금고',
        logoUrl: 'https://fctalk.co.kr/img/damoa/mg_k.jpg',
        systemUrl: 'https://insu.kfcc.co.kr/main.do',
        customerCenter: [tel('1599-9010')],
        inCall: [txt('-')],
        helpDesk: [txt('-')],
        claimFax: [tel('02-3016-7674')],
        termsUrl: 'https://insu.kfcc.co.kr/ino/inoGuide.do',
        formUrl: 'https://drive.google.com/file/d/1fczSB7XNrICO7EJ-wV3PyHqdhZ47Sdws/view?usp=drive_link',
      },
      {
        name: 'TheK',
        logoUrl: 'https://fctalk.co.kr/img/damoa/thek_k.jpg',
        systemUrl: 'https://www.ktcu.or.kr/MH/MH-P010M01.do',
        customerCenter: [tel('1577-3993')],
        inCall: [txt('-')],
        helpDesk: [txt('-')],
        claimFax: [tel('02-3278-9696')],
        termsUrl: 'https://www.ktcu.or.kr/IS/IS-P170M01.do',
        formUrl: 'https://drive.google.com/file/d/19-6IKwH3Nld0BUK5xkQATvs716X_iAzg/view?usp=drive_link',
      },
      {
        name: '우체국보험',
        logoUrl: 'https://fctalk.co.kr/img/damoa/letter_k.jpg',
        systemUrl: 'https://epostlife.go.kr/LNLNDM10DM.do',
        customerCenter: [tel('1599-0100')],
        inCall: [txt('-')],
        helpDesk: [txt('-')],
        claimFax: [
          txt('팩스: 0505-005-지역별번호'),
          txt('1224(서울) 1427(경인동부) 1428(경인서부) 2271(강원)'),
          txt('1788(충청) 2163(전북) 1921(전남) 1623(부산) 2070(경북) 7116(서귀포) 2296(제주)'),
        ],
        termsUrl: 'https://mall.epostbank.go.kr/IPPSKE0000.do',
        formUrl: 'https://drive.google.com/file/d/1pjdiYg1hItIHnNX2iKaPOzBy-CThYNSL/view?usp=drive_link',
      },
      {
        name: '수협',
        logoUrl: 'https://fctalk.co.kr/img/damoa/suh_k.jpg',
        systemUrl: 'https://www.suhyup-bank.com/',
        customerCenter: [tel('1588-4119')],
        inCall: [txt('-')],
        helpDesk: [txt('-')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://www.suhyup-bank.com/ib20/mnu/FPD00127#859',
        formUrl: 'https://drive.google.com/file/d/1GIj-qQ-vkCR_wB6CsuzVi7yoJQ-sh0u8/view?usp=drive_link',
      },
      {
        name: '신협',
        logoUrl: 'https://fctalk.co.kr/img/damoa/sin_k.jpg',
        systemUrl: 'https://openbank.cu.co.kr/?sub=6000',
        customerCenter: [tel('1544-3030')],
        inCall: [txt('-')],
        helpDesk: [txt('-')],
        claimFax: [txt('고객센터에 전화')],
        termsUrl: 'https://openbank.cu.co.kr/?sub=6000',
        formUrl: 'https://drive.google.com/file/d/1uMwFZEuwe44_7d6apbfG_sL2XLCkAxWR/view?usp=drive_link',
      },
    ],
  },
]

export const insurerSystemsHelpers = { ext, tel, txt }

